// Rows of three; a remainder of one joins the first row, so seven cards read 4 + 3 rather than leaving
// one card alone on a third row.
export const getHighlightRowSizes = (count: number) => {
  const rowSizes = Array.from({ length: Math.floor(count / 3) }, () => 3);
  const remainder = count % 3;
  if (remainder === 1 && rowSizes.length > 0) rowSizes[0] = 4;
  else if (remainder > 0) rowSizes.push(remainder);

  return rowSizes;
};
